"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var _DashboardTopbar = _interopRequireDefault(require("./DashboardTopbar"));

var _components = require("../../components");

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      paddingTop: 56
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      paddingTop: 64
    }), _defineProperty(_root, "display", 'flex'), _defineProperty(_root, "minHeight", '100vh'), _root),
    shiftContent: {
      paddingLeft: 240
    },
    content: {
      backgroundColor: theme.palette.background.default,
      flexGrow: 1
    }
  };
});

var Dashboard = function Dashboard(_ref) {
  var _clsx;

  var children = _ref.children,
      navMenu = _ref.navMenu,
      profileProps = _ref.profileProps,
      topBarProps = _ref.topBarProps,
      langProps = _ref.langProps,
      onSignOut = _ref.onSignOut;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openSidebar = _useState2[0],
      setOpenSidebar = _useState2[1];

  var handleSidebarOpen = function handleSidebarOpen() {
    setOpenSidebar(true);
  };

  var handleSidebarClose = function handleSidebarClose() {
    setOpenSidebar(false);
  };

  var shouldOpenSidebar = isDesktop ? true : openSidebar;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)((_clsx = {}, _defineProperty(_clsx, classes.root, true), _defineProperty(_clsx, classes.shiftContent, isDesktop), _clsx))
  }, /*#__PURE__*/_react.default.createElement(_DashboardTopbar.default, _extends({
    onSidebarOpen: handleSidebarOpen,
    onSignOut: onSignOut
  }, topBarProps)), /*#__PURE__*/_react.default.createElement(_Sidebar.default, {
    onClose: handleSidebarClose,
    open: shouldOpenSidebar,
    variant: isDesktop ? 'persistent' : 'temporary',
    navMenu: navMenu,
    profileProps: profileProps,
    onSignOut: onSignOut,
    langProps: langProps
  }), /*#__PURE__*/_react.default.createElement("main", {
    className: classes.content
  }, children, /*#__PURE__*/_react.default.createElement(_components.Footer, null)));
};

Dashboard.propTypes = {
  children: _propTypes.default.node,
  navMenu: _propTypes.default.node.isRequired
};
var _default = Dashboard;
exports.default = _default;